import { render, staticRenderFns } from "./BulkUpdateStandardOperations.vue?vue&type=template&id=798119d7&"
import script from "./BulkUpdateStandardOperations.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateStandardOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports